import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import styles from "./mob_menu.module.css";
import MobCatalog from "../mob_catalog/mob_catalog";
import { useSelector } from "react-redux";
import { getCategories } from "../../../services/selectors";


function MobMenu() {

  const { categories } = useSelector(getCategories);

  const [isOpen, setIsOpen] = useState(false);
  const [parentCat, setParentCat] = useState({});
  const [currCategories, setCurrCategories] = useState([]);

  const handleOpenCatalog = () => {
    setIsOpen(!isOpen);
    setParentCat({});
    setCurrCategories(categories);
  }
  const handleChangeCat = (id) => {
    setParentCat(currCategories.find(item => item.id === id));
    console.log('id =', id);
  }

  useEffect(() => {
    if (!parentCat.id) {
      setCurrCategories(categories);
    } else {
      console.log('new arr =', parentCat.children.slice(0))
      setCurrCategories(parentCat.children.slice(0));
    }
  }, [parentCat]);

  return (
    <>
      <Link to="/catalog"
        className={styles.buttonLink}
        onClick={handleOpenCatalog}
      >Каталог
      </Link>

      {isOpen &&
        MobCatalog({
          currCategories, parentCat,
          handleChangeCat
        })
      }

      <Link to="/"
        className={styles.buttonLink}
        // onClick={handleOpenCatalog}
      >Главная
      </Link>
      <Link to="/about"
        className={styles.buttonLink}
        // onClick={handleOpenCatalog}
      >О магазине
      </Link>
      <Link to="/articles"
        className={styles.buttonLink}
        // onClick={handleOpenCatalog}
      >Статьи
      </Link>
      <Link to="/docs"
        className={styles.buttonLink}
        // onClick={handleOpenCatalog}
      >Документация и ПО
      </Link>
      <Link to="/pay"
        className={styles.buttonLink}
        // onClick={handleOpenCatalog}
      >Оплата
      </Link>
      <Link to="/delivery"
        className={styles.buttonLink}
        // onClick={handleOpenCatalog}
      >Доставка
      </Link>
      <Link to="/contacts"
        className={styles.buttonLink}
        // onClick={handleOpenCatalog}
      >Контакты
      </Link>
    </>
  );
}

export default MobMenu;
